import { FormatterMode } from "../mode.js";
export const FORMATTER_EXAMPLES = [
    {
        id: "format-text-for-web",
        label: "Text for Web",
        slug: "format-text-for-web",
        contentType: FormatterMode.Web,
        options: {
            detectHeadings: true,
            detectLists: true,
            detectColonLabels: false,
        },
        text: `Why choose our service? TextFormatter helps you clean, structure, and improve your text in seconds. It automatically removes formatting issues, fixes spacing, and converts messy content into clear, well-structured text. Whether you are preparing content for the web, e-commerce listings, or documents, our tool saves time and ensures consistent formatting. No manual editing, no frustration—just paste your text and get a polished result instantly.`,
    },
    {
        id: "eshop-product",
        label: "E-shop Product",
        slug: "eshop-product",
        contentType: FormatterMode.Ecommerce,
        options: {
            detectHeadings: false,
            detectLists: false,
            detectColonLabels: true,
            splitAfterSentenceEnd: false,
            nutritionBlockParsing: false,
        },
        text: `Ingredients: rooibos (88.5%)*, cocoa nibs (6%)*, natural flavor (5%), vanilla pods (0.5%)* *organic Storage: Store the tea in a dry and cool place, do not expose to direct sunlight.`,
    },
    {
        id: "company-address",
        label: "Company + Address",
        slug: "company-address",
        contentType: FormatterMode.Web,
        options: {
            headingStyle: "h2",
            detectHeadings: true,
            detectLists: false,
            detectColonLabels: true,
        },
        text: `TextFormatter LTD\n
Registered office: Manhattan: 721 Broadway, New York, NY 10003, USA
Company ID: 123456789
VAT ID: US123456789`,
    },
    {
        id: "faq-snippet",
        label: "FAQ Snippet",
        slug: "faq-snippet",
        contentType: FormatterMode.Web,
        options: {
            detectHeadings: true,
            detectLists: false,
            detectColonLabels: false,
        },
        text: `How does delivery work? Orders received by 2:00 PM are shipped the same day. When will my package arrive? In most locations, we deliver within 24 to 48 hours.`,
    },
    {
        id: "convert-text-to-html",
        label: "Text to HTML",
        slug: "convert-text-to-html",
        contentType: FormatterMode.Web,
        options: {
            headingStyle: "h2",
            detectHeadings: true,
            detectLists: true,
            detectColonLabels: false,
        },
        text: `This will be heading
This will be list item under heading.

This will be paragraph text.

This will be another paragraph.

- This will be list item 1
- This will be list item 2
- This will be list item 3`,
    },
];
